<!-- =========================================================================================
    File Name: V2PageLoader.vue
    Description: Component for loading and displaying pages from version 2 (v2) of the application in an iframe.
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <iframe
    class="v2_page_loader"
    :src="iframeSrc"
    allow="clipboard-write; fullscreen"
    allowfullscreen
  />
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      iframeSrc: '',
    };
  },

  watch: {
    $route(to) {
      this.updateIframeSource(to.path);
    },
  },

  methods: {
    async updateIframeSource(path) {
      try {
        const currentPath = path !== '/dashboard' ? path : '/';
        const appOrigin = this.getAppOrigin();
        const childOrigin = this.getChildOrigin();
        const authToken = this.getAuthToken();

        const newToken = await this.fetchNewToken(authToken);
        this.iframeSrc = this.buildIframeSource(
          childOrigin,
          currentPath,
          appOrigin,
          newToken,
        );
      } catch (error) {
        console.error('Error updating iframe source:', error);
      }
    },

    getAppOrigin() {
      return new URL(document.documentURI).origin;
    },

    getChildOrigin() {
      return process.env.VUE_APP_V2_BASE_URL;
    },

    getAuthToken() {
      return window.localStorage.getItem('user-token') || '';
    },

    async fetchNewToken(authToken) {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_V2_API_BASE_URL}/authentication/refine-user-data`,
          {
            token: authToken,
          },
        );

        return response.data.token;
      } catch (error) {
        throw error;
      }
    },

    buildIframeSource(childOrigin, path, appOrigin, authToken) {
      return `${childOrigin}${path}?origin=${appOrigin}&authToken=${authToken}&isIndexedMode=true`;
    },
  },

  mounted() {
    this.updateIframeSource(this.$route.path);
  },
};
</script>

<style lang="scss">
.v2_page_loader {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
